var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_setup.loading),expression:"loading"}],staticClass:"chart-container"},[_c(_setup.MobAreaChart,{attrs:{"data":_setup.currentKlineData,"chartColor":_setup.chartColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }